export default {"src":"/uk/_next/static/media/connectIcon.c7fdba90.svg","height":60,"width":60,"blurWidth":0,"blurHeight":0};